import { PhoneNumber, PhoneNumberType, PhoneNumberUtil } from 'google-libphonenumber';
import { Translate, Validator } from 'react-admin';

const phoneUtilInstance = PhoneNumberUtil.getInstance();

interface PhoneNumberValidatorOptions {
  mobileOnly?: boolean;
}

const validatePhoneNumberCore = (
  translate: Translate,
  value: unknown,
  options?: PhoneNumberValidatorOptions,
): string | undefined => {
  // Phone fields are text inputs; anything else is treated as empty and left to `required`.
  const phoneNumberStr =
    typeof value === 'string' || typeof value === 'number' ? String(value).trim() : '';

  if (!phoneNumberStr) {
    return undefined;
  }

  if (!phoneNumberStr.startsWith('+')) {
    return translate('resources.bo_common.validation.invalid_international_phone_number_format');
  }

  try {
    const phoneNumber: PhoneNumber = phoneUtilInstance.parseAndKeepRawInput(phoneNumberStr);
    if (!phoneUtilInstance.isValidNumber(phoneNumber)) {
      return translate('resources.bo_common.validation.invalid_international_phone_number');
    }

    if (options?.mobileOnly) {
      const numberType = phoneUtilInstance.getNumberType(phoneNumber);
      if (
        numberType !== PhoneNumberType.MOBILE &&
        numberType !== PhoneNumberType.FIXED_LINE_OR_MOBILE
      ) {
        return translate('resources.bo_common.validation.invalid_mobile_phone_number');
      }
    }
  } catch {
    return translate('resources.bo_common.validation.invalid_international_phone_number_format');
  }

  return undefined;
};

export const createPhoneNumberValidator =
  (translate: Translate, options?: PhoneNumberValidatorOptions): Validator =>
  (value) =>
    validatePhoneNumberCore(translate, value, options);
